import { Injectable, inject } from '@angular/core';

import { MessageEnvelope } from '@cds/push';
import { ApiService } from '@frontend/sports/common/api-utils';
import { InternalFeaturesConfig } from '@frontend/sports/common/client-config-data-access';
import { BaseCustomLogger } from '@frontend/sports/common/core/feature/logging';

@Injectable({
    providedIn: 'root',
})
export class EPSPushLogger extends BaseCustomLogger<MessageEnvelope> {
    private internalConfig = inject(InternalFeaturesConfig);

    constructor() {
        const api = inject(ApiService);

        super(api, 'epslogger/logpush');
    }

    protected override isEnabled = (): boolean => this.internalConfig.isEPSDetailedLoggingEnabled;
}
